"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var CreateEntityAssignment = /** @class */ (function () {
    function CreateEntityAssignment(json) {
        this.entity = json.entity;
        this.securityRoleId = json.securityRoleId;
        this.type = json.type;
    }
    __decorate([
        mobx_1.observable
    ], CreateEntityAssignment.prototype, "entity", void 0);
    __decorate([
        mobx_1.observable
    ], CreateEntityAssignment.prototype, "securityRoleId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateEntityAssignment.prototype, "type", void 0);
    return CreateEntityAssignment;
}());
exports.CreateEntityAssignment = CreateEntityAssignment;
var UpdateUser = /** @class */ (function () {
    function UpdateUser() {
        this.name = '';
        this.email = '';
        this.showPassword = false;
        this.registerPasscode = '';
        this.entityAssignments = [];
    }
    UpdateUser.prototype.getCreateObject = function () {
        return {
            name: this.name,
            email: this.email ? this.email : null,
            password: this.password ? this.password : null,
            registerPasscode: this.registerPasscode ? this.registerPasscode : null,
            entityAssignments: this.entityAssignments.filter(function (e) { return e.type === 'assigned'; }),
        };
    };
    UpdateUser.prototype.getUpdateObject = function () {
        var password;
        if (this.showPassword) {
            if (this.password) {
                password = this.password;
            }
            else {
                password = null;
            }
        }
        else {
            password = undefined;
        }
        return {
            id: this.id,
            name: this.name,
            email: this.email ? this.email : null,
            password: password,
            registerPasscode: this.registerPasscode ? this.registerPasscode : null,
            entityAssignments: this.entityAssignments.filter(function (e) { return e.type === 'assigned'; }),
        };
    };
    UpdateUser.prototype.addAssignment = function (entity) {
        this.entityAssignments.push(new CreateEntityAssignment({
            entity: { id: undefined },
            securityRoleId: undefined,
            type: 'assigned',
        }));
    };
    Object.defineProperty(UpdateUser.prototype, "isValid", {
        get: function () {
            // All entity ids should be unique
            var uniqueAssignments = lodash_1.uniq(this.entityAssignments.filter(function (e) { return e.type === 'assigned'; }).map(function (e) { return e.entity.id; }));
            var assignedAssignments = this.entityAssignments.filter(function (e) { return e.type === 'assigned'; });
            if (uniqueAssignments.length !== assignedAssignments.length) {
                return false;
            }
            // All location assignments should have a security role attached
            if (this.entityAssignments.filter(function (e) { return e.type === 'assigned'; }).find(function (e) { return e.entity.id === undefined; })) {
                return false;
            }
            // All location assignments should have a security role attached
            if (this.entityAssignments.filter(function (e) { return e.type === 'assigned'; }).find(function (e) { return e.securityRoleId === undefined; })) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "email", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "showPassword", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "password", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "registerPasscode", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateUser.prototype, "entityAssignments", void 0);
    __decorate([
        mobx_1.computed
    ], UpdateUser.prototype, "isValid", null);
    return UpdateUser;
}());
exports.UpdateUser = UpdateUser;
//# sourceMappingURL=User.js.map